import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import Login from '../views/login/Login.vue'
import SiderCharts from '../components/dataList/lineCharts.vue'
import store from '@/store/index.js'

import rules from './ruleEngine'
import template from './template'
import categoryManager from './categoryManager'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    redirect: '/home',
    component: Main,
    children: [
      {
        path: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/about/About.vue'),
        meta: { title: '公司介绍' }
      },
      {
        path: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/Home.vue')
      },
      // 设备管理相关页面
      {
        path: '/deviceManagement/DeviceManager',
        component: () => import('@/views/deviceManagement/DeviceManager'),
        meta: { title: '设备管理' }
      },
      {
        path: 'deviceManagement/DeviceDetail',
        name: 'hasParent/deviceManagement/DeviceManager',
        component: () => import('@/views/deviceManagement/DeviceDetail'),
        meta: { title: '设备详情' }
      },
      {
        path: 'deviceManagement/subDeviceDetail',
        name: 'hasParent/deviceManagement/DeviceManager',
        component: () => import('@/views/deviceManagement/subDeviceDetail'),
        meta: { title: '子设备详情' }
      },
      {
        path: 'hello',
        component: () => import('@/views/about/productDes.vue'),
        meta: { title: '产品介绍' }
      },
      // 产品注册模块
      {
        path: '/productControl/snManagement',
        name: 'snManagement',
        component: () => import('@/views/productControl/snManagement'),
        meta: { title: 'SN管理' }
      },
      {
        path: '/productControl/vendorManagement',
        name: 'vendorManagement',
        component: () => import('@/views/productControl/vendorManagement'),
        meta: { title: '厂商管理' }
      },
      {
        path: '/productControl/modelManagement',
        name: 'modelManagement',
        component: () => import('@/views/productControl/modelManagement'),
        meta: { title: '型号管理' }
      },
      {
        path: '/productControl/productRegistration',
        name: 'productRegistration',
        component: () => import('@/views/productControl/productRegistration'),
        meta: { title: '产品注册' }
      },
      {
        path: '/productControl/productEdit',
        name: 'hasParent/productControl/productEdit',
        component: () => import('@/views/productControl/productEdit'),
        meta: { title: '编辑产品' }
      },
      {
        path: '/productControl/productDetail',
        name: 'hasParent/productControl/productRegistration',
        component: () => import('@/views/productControl/productDetail'),
        meta: { title: '产品详情' }
      },
      {
        path: '/productControl/functionDefinitionEdit',
        name: 'hasParent/productControl/productRegistration',
        component: () => import('@/components/product_control/functionDefinitionEdit'),
        meta: { title: '编辑草稿' }
      },
      // CA证书
      {
        path: '/productControl/CACertificate',
        component: () => import('@/views/productControl/CACertificate'),
        meta: { title: 'CA证书' }
      },
      // CA证书详情
      {
        path: '/productControl/certificateDetail',
        name: 'hasParent/productControl/CACertificate',
        component: () => import('@/views/productControl/certificateDetail'),
        meta: { title: 'CA证书详情' }
      },
      // 数据统计模块
      {
        path: '/dataStatistics',
        name: 'dataStatistics',
        component: () => import('@/views/dataStatistics'),
        meta: { title: '数据统计' }
      },
      // 数据统计模块（新开发）
      {
        path: '/taskManage',
        name: 'taskManage',
        component: () => import('@/views/dataStatistics/taskManage'),
        meta: { title: '任务管理' }
      },
      {
        path: '/dataStatistics/log',
        name: 'taskManage',
        component: () => import('@/components/dataList/log.vue'),
        meta: { title: '调度日志' }
      },
      // 系统运维
      {
        path: '/sytem/systemopra',
        name: 'systemopra',
        component: () => import('@/components/systemOperation/systemOperation.vue'),
        meta: { title: '实时监控' }
      },
      {
        path: '/SystemOper/firmwareUpdate',
        name: 'firmwareUpdate',
        component: () => import('@/views/SystemOper/firmwareUpdate.vue'),
        meta: { title: '固件升级' }
      },
      {
        path: '/SystemOper/firmwareDetail',
        name: 'hasParent/SystemOper/firmwareUpdate',
        component: () => import('@/views/SystemOper/firmwareDetail'),
        meta: { title: '固件详情' }
      },
      {
        path: '/SystemOper/firmwareBatchDetail',
        name: 'hasParent/SystemOper/firmwareUpdate',
        component: () => import('@/views/SystemOper/firmwareBatchDetail'),
        meta: { title: '批次详情' }
      },
      {
        path: '/sytem/logService',
        name: 'dataStatistics',
        component: () => import('@/components/systemOperation/logService.vue'),
        meta: { title: '日志服务' }
      },
      // 系统管理模块
      {
        path: '/systemManagement/charactorManager',
        name: 'charactorManager',
        component: () => import('@/views/systemManagement/charactorManager'),
        meta: { title: '角色管理' }
      },
      {
        path: '/systemManagement/userManager',
        name: 'charactorManager',
        component: () => import('@/views/systemManagement/userManager'),
        meta: { title: '用户管理' }
      },
      {
        path: '/systemManagement/permissionManager',
        name: 'permissionManager',
        component: () => import('@/views/systemManagement/permissionManager'),
        meta: { title: '权限管理' }
      },
      {
        path: '/systemManagement/modelManager',
        name: 'charactorManager',
        component: () => import('@/views/systemManagement/modelManager'),
        meta: { title: '模块管理' }
      },
      {
        path: '/systemManagement/pwdUpdate',
        name: 'pwdUpdate',
        component: () => import('@/views/systemManagement/passwordUpdate.vue'),
        meta: { title: '密码修改' }
      },
      {
        path: '/systemManagement/organizationManager',
        name: 'organizationManager',
        component: () => import('@/views/systemManagement/organizationManager.vue'),
        meta: { title: '组织管理' }
      },
      {
        path: '/systemManagement/buttonsManager',
        name: 'buttonsManager',
        component: () => import('@/views/systemManagement/buttonsManager.vue'),
        meta: { title: '按钮管理' }
      },
      ...rules,
      ...template,
      // 品类管理
      ...categoryManager
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/siderCharts',
    name: 'siderCharts',
    component: SiderCharts
  },
  {
    path: '*',
    name: '找不到页面',
    component: () => import('@/components/error/page404.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  // console.log('push location:', location)
  return originalPush.call(this, location).catch(err => err)
}

// 跳转拦截
router.beforeEach((to, from, next) => {
  const isLogin = store.state.token || localStorage.getItem('authorization')
  if (isLogin) {
    next()
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
  console.log('to----', to)
  // console.log('from----', from)
})
export default router
